<template>
	<div class="Footer-badges">
		<a v-for="(badge, key) in badges" :key="key" :href="badge.url">
			<img :src="badgeBaseUrl + badge.image" :alt="badge.altText" />
		</a>
	</div>
</template>

<script>
export default {
	name: 'CloFooterBadges',
	props: {
		badges: {
			type: Array,
			required: true,
		},
		badgeBaseUrl: {
			type: String,
			default: 'https://clo-brand-static-prod.s3.amazonaws.com/badges/',
		},
	},
};
</script>

<style lang="scss">
.Footer-badges {
	display: flex;
	flex-wrap: wrap;
	gap: $space-xs;
}
</style>
